import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "animate.css";
import WOW from "wow.js";
import "./assets/css/style.css";
import "./assets/css/font.css";

Vue.use(ElementUI);
Vue.config.productionTip = false;

// 全局配置Element UI
Vue.prototype.$ELEMENT = { size: "medium" };

// 配置 WOW.js
const wow = new WOW({
  boxClass: "wow",
  animateClass: "animate__animated",
  offset: 0,
  mobile: true,
  live: true,
  callback: function (box) {
    // 添加动画类
    box.classList.add("animate__animated");
  },
});
Vue.prototype.$wow = wow;

// 创建一个简单的事件总线
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
